import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, addDoc, getDocs, doc, updateDoc, deleteDoc } from 'firebase/firestore';

function CustomerManagement() {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);

    // State for the form
    const [currentCustomer, setCurrentCustomer] = useState({ name: '', country: '', companyCode: '' });
    const [isEditing, setIsEditing] = useState(false);

    // Fetch all customers from Firestore
    const fetchCustomers = async () => {
        setLoading(true);
        const querySnapshot = await getDocs(collection(db, 'customers'));
        const customersData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setCustomers(customersData);
        setLoading(false);
    };

    useEffect(() => {
        fetchCustomers();
    }, []);

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setCurrentCustomer(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!currentCustomer.name || !currentCustomer.country || !currentCustomer.companyCode) {
            alert("All fields (Name, Country, and Company Code) are required.");
            return;
        }

        if (isEditing) {
            // Update existing customer
            const customerDoc = doc(db, 'customers', currentCustomer.id);
            await updateDoc(customerDoc, { name: currentCustomer.name, country: currentCustomer.country, companyCode: currentCustomer.companyCode });
        } else {
            // Add new customer
            await addDoc(collection(db, 'customers'), { name: currentCustomer.name, country: currentCustomer.country, companyCode: currentCustomer.companyCode });
        }
        
        resetForm();
        fetchCustomers(); // Refresh the list
    };
    
    const handleEdit = (customer) => {
        setIsEditing(true);
        setCurrentCustomer(customer);
    };

    const handleDelete = async (customerId) => {
        if (window.confirm("Are you sure you want to delete this customer?")) {
            const customerDoc = doc(db, 'customers', customerId);
            await deleteDoc(customerDoc);
            fetchCustomers(); // Refresh the list
        }
    };

    const resetForm = () => {
        setIsEditing(false);
        setCurrentCustomer({ name: '', country: '', companyCode: '' });
    };

    return (
        <div>
            <h2>Manage Customers</h2>
            <div style={{ padding: '20px', border: '1px solid #ccc', marginBottom: '20px' }}>
                <h3>{isEditing ? 'Edit Customer' : 'Add New Customer'}</h3>
                <form onSubmit={handleSubmit}>
                    <input name="name" value={currentCustomer.name} onChange={handleFormChange} placeholder="Customer Name (e.g., Pharma Corp Inc.)" required />
                    <input name="country" value={currentCustomer.country} onChange={handleFormChange} placeholder="Country (e.g., USA)" required style={{ marginLeft: '10px' }} />
                    {/* FIX: Removed the '+' sign from the beginning of this line */}
                    <input name="companyCode" value={currentCustomer.companyCode} onChange={handleFormChange} placeholder="Company Code (e.g., PCI)" required style={{ marginLeft: '10px' }} />
                    <button type="submit" style={{ marginLeft: '10px' }}>{isEditing ? 'Update Customer' : 'Add Customer'}</button>
                    {isEditing && <button type="button" onClick={resetForm} style={{ marginLeft: '10px' }}>Cancel</button>}
                </form>
            </div>

            <h3>Existing Customers</h3>
            {loading ? <p>Loading customers...</p> : (
                <table border="1" cellPadding="5" width="100%">
                    <thead><tr><th>Customer Name</th><th>Company Code</th><th>Country</th><th>Actions</th></tr></thead>
                    <tbody>
                        {customers.map(customer => (
                            <tr key={customer.id}>
                                <td>{customer.name}</td>
                                <td>{customer.companyCode}</td>
                                <td>{customer.country}</td>
                                <td>
                                    <button onClick={() => handleEdit(customer)}>Edit</button>
                                    <button onClick={() => handleDelete(customer.id)} style={{ marginLeft: '10px' }}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

export default CustomerManagement;